import { navItemType } from '~/constants/nav-footer-v2';
import { useLayoutStore } from '~/providers/layout-store-provider';

import ScrollableRow from '../ScrollableRow';
import WrappedIcon from '../WrappedIcon';

import styles from './FeaturedMenu.module.css';

export const FeaturedMenu = () => {
  const featuredLinks = useLayoutStore(
    (s) =>
    s.navData.mobileBottomNav.find(
      (item) => item.type === navItemType.ALL_SPORTS_EXPANDABLE
    )?.items?.featuredLinks || []
  );

  return (
    <ScrollableRow className={styles.featuredMenu}>
			{featuredLinks.map((item) =>
      <a className={styles.featuredItem} href={item.link} key={item.name}>
					<WrappedIcon
          className={styles.featuredIcon}
          dimensionString="32"
          iconString={item.icon} />

					{item.name}
				</a>
      )}
		</ScrollableRow>);

};